module.exports = __webpack_public_path__ + "static/pic02-94cc4ac3d6147b002cc6ad15bc3e9f25.jpg";